import React, {Component} from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import './styles/index.css'

export default class WeatherResponse extends Component {
    render() {
        return (
            <div>
                {(!this.props.airports || this.props.airports.length === 0)
                    ? <span className='no-weather'>{this.props.noWeatherText}</span>
                    : this.props.airports.map((airport, index) => (
                        <div className="weather-content spark-pad-b-2 spark-mar-b-2" key={index}>
                            <h4>{(airport.Forecasts || []).some(forecast => forecast.Type === 'FV')
                                ? `${airport.icao} - Volcanic Ash`
                                : airport.icao}
                            </h4>
                            <span className="forecasts">{(airport.Forecasts === undefined || airport.Forecasts.length === 0)
                                ? 'No weather found for requested criteria'
                                : airport.Forecasts.map(renderForecast)}
                            </span>
                        </div>)
                )}
            </div>
        )
    }
}

const renderForecast = (forecast, index) => {
    return (
        <span key={index} className="weather-row">
            <span className="weather-type">
                <b>{forecast.Type} </b>
            </span>
            {forecast.Type === "FT" || forecast.Type === "FC" ?
                <span className="weather-complex-time">
                    {moment(forecast.CreationTime).utc().format("DDHHmm[Z]")}{" "}
                    {moment(forecast.Svt).utc().format("DDHH")}{"/"}
                    {moment(forecast.Evt).utc().format("DDHH")}{" "}
                </span> :
                <span className="weather-svt">
                    {moment(forecast.Svt).utc().format("DDHHmm[Z]")}{" "}
                </span>
            }
            <span
                className="weather-text"
                dangerouslySetInnerHTML={{
                    __html:
                        forecast.Text !== undefined && forecast.Text !== null
                            ? forecast.Text.replace("\n", "<br />")
                            : "",
                }}
            />
            <br />
        </span>
    );
};

WeatherResponse.propTypes = {
    airports: PropTypes.array,
    noWeatherText: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/shared/components/WeatherResponse/index.js